import { createFileRoute, useParams } from "@tanstack/react-router";

import { ShowPage } from "@/components/explore/show-page";
import { episodesInfiniteQuery, showQuery } from "@/lib/queries";
import { queryClient } from "@/lib/query-client";

const ShowRoute = () => {
  const { showId } = useParams({ from: "/view/shows/$showId" });

  return <ShowPage showId={showId} />;
};

export const Route = createFileRoute("/view/shows/$showId")({
  component: ShowRoute,

  /**
   * Both fetches start during navigation rather than after hydration, and
   * `ensure*` is a no-op when the cache is already warm — which it usually is,
   * since the visitor arrived from a list that seeded it.
   */
  loader: ({ params }) =>
    Promise.all([
      queryClient.ensureQueryData(showQuery(params.showId)),
      queryClient.ensureInfiniteQueryData(episodesInfiniteQuery(params.showId)),
    ]),
});
